export const isAuthorizedUser = () => {
    return !!window.catalogue.state.account?.id;
};

export const getUserId = () => {
    return window.catalogue.state.account?.id ?? null;
};
